import Cookies from "js-cookie";

const COOKIE_OPTIONS = {
  secure: import.meta.env.PROD, // HTTPS only in production
  sameSite: "strict",
};

/**
 * Cookie options for auth tokens (shorter expiration)
 * Use this for access tokens and refresh tokens
 */
const AUTH_COOKIE_OPTIONS = {
  ...COOKIE_OPTIONS,
  expires: 30 / 1440, // 30 minutes (in days: 30 min / 1440 min per day)
};

/**
 * Cookie options for persistent data (longer expiration)
 * Use this for user preferences, theme, language, etc.
 */
const PERSISTENT_COOKIE_OPTIONS = {
  ...COOKIE_OPTIONS,
  expires: 30, // 30 days
};

/**
 * Removes a cookie by key
 * @param {string} key - The cookie key to remove
 */
export const dropStorage = key => {
  Cookies.remove(key);
};

/**
 * Sets a cookie with the provided key and payload
 * @param {string} key - The cookie key
 * @param {any} payload - The data to store (will be JSON stringified)
 * @param {Object} options - Additional cookie options (optional)
 */
export const setStorage = (key, payload, options = {}) => {
  const cookieOptions = {...COOKIE_OPTIONS, ...options};
  Cookies.set(key, JSON.stringify(payload), cookieOptions);
};

/**
 * Gets and parses a cookie value by key
 * @param {string} key - The cookie key to retrieve
 * @returns {any|null} - The parsed cookie value or null if not found
 */
export const getStorage = key => {
  const cookieValue = Cookies.get(key);
  if (!cookieValue) {
    return null;
  }

  try {
    return JSON.parse(cookieValue);
  } catch (_error) {
    return null;
  }
};

export {AUTH_COOKIE_OPTIONS, PERSISTENT_COOKIE_OPTIONS};
